import { jsml } from "../jsml.js";
import { iml } from "../iml.js";
// import { splitLines } from "./../splitLines.js";

export function methodDisplaySpecialOffers(request, $url = "") {
  // Get current language
  const getCurrentLanguage = () => {
    return document.getElementById("current_language").dataset.language;
  };

  //const language = getQueryString($url, 'lang')
  const language = getCurrentLanguage() || "en";
  let renderHTML = "";

  let activeIds = [];

  if (!request[0]) {
    document.getElementById("filter-results").innerHTML = renderHTML;
  }

  request.forEach((room, i) => {
    let rowreverse = i % 2 == 1 ? "flex-row-reverse" : "flex-row";

    // Prepare Images
    let secondaryImg = "";
    let primaryImg = "";

    // Prepare secondary Image
    if (room.acf.featured_image_2) {
      secondaryImg =
        '<div class="w-50 m-w-100 sm-hide-down"><img class="m-res-h bg-primary div-fill-soft row-600 m-row-260 m-w-100" src="' +
        room.acf.featured_image_2.sizes.large +
        '" alt="" lazy></img></div>';
    }

    // Prepare first image, depending on if 1 or two images are displayed
    if (room.fimg_url) {
      if (room.acf.featured_image_2) {
        primaryImg += '<div class="w-50 m-w-100">';
      }
      primaryImg +=
        '<img class="m-res-h bg-primary div-fill-soft row-600 m-row-260 m-w-100" src="' +
        room.fimg_url +
        '" alt="'+ room.title.rendered  +'" lazy>';
      if (room.acf.featured_image_2) {
        primaryImg += "</div>";
      }
    }

    if (room.acf) {
      //let structureComparison = JSON.stringify({ 'id': room.id, 'title' : room.acf.title_text_line_1 + ' ' + room.acf.title_text_line_2, 'room' : room.acf.size, 'number_of_units' : room.acf.number_of_units, 'rates' : room.acf.rates, 'view' : room.acf.view, 'beds' : room.acf.beds, 'floors' : room.acf.floors });

      renderHTML += `<div data-filter-id="${
        room.id
      }" class="landscape-image-text-block site-width flex justify-end gap-135 m-flex-wrap m-gap-0  m-flex-column-reverse mv-140 align-items-center ${rowreverse}" data-type="organism" data-temp="introduction-and-award-block.twig">
                            <div class="col col-420 m-w-100" data-animation="text-animation-1">
                                    <p class="mv-40 fs-18 tt-uppercase">${jsml(
                                      language,
                                      "Offer"
                                    )}</p>
                               
                                    <p class="fs-40 ff-2 i-gold">${iml(
                                      room.title.rendered
                                    )}</p>
                                
                                <p>${room.excerpt.rendered
                                  .replace(/(<([^>]+)>)/gi, "")
                                  .substring(0, 200)}</p>
                                <!-- Handle Download, External and Internal Links -->
                                <div class="flex gap-36 m-inherit">
                                    <a class="btn" href="${room.link}">${jsml(
        language,
        "View Offer"
      )}</a>
                                </div>
                            </div>
                            <a href="${
                              room.link
                            }" class="col-1055 align-self-stretch m-w-100 flex gap-36 m-gap-0 m-flex-wrap m-mb-30" data-animation="image-animation-2">
                                ${primaryImg}
                                ${secondaryImg}
                            </a>
                           </div>`;
    }

    // http://thereverie-2021_staging.local/wp-json/wp/v2/media/${room.featured_media}
  });

  let html = new DOMParser().parseFromString(renderHTML, "text/html");
  html = html.getRootNode();

  document.getElementById("filter-results").innerHTML = "";
  document.getElementById("filter-results").append(html.body);

  // Handle Slot Event Listener
  let results = document.querySelectorAll(".add-to-slot");
  results.forEach((result) => {
    result.addEventListener("click", function () {
      // console.log('clicked');
    });
  });

  // Init Split Lines
  // splitLines(document.querySelectorAll("#filter-results p"));
}
